var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFaceLaugh16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8571 8.64286C11.8571 10.7731 10.1302 12.5 7.99999 12.5C5.86975 12.5 4.14285 10.7731 4.14285 8.64286H11.8571Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71428 6.07144C6.71428 6.78152 6.13864 7.35715 5.42856 7.35715C4.71848 7.35715 4.14285 6.78152 4.14285 6.07144C4.14285 5.36135 4.71848 4.78572 5.42856 4.78572C6.13864 4.78572 6.71428 5.36135 6.71428 6.07144Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5714 7.35715C11.2815 7.35715 11.8571 6.78152 11.8571 6.07144C11.8571 5.36135 11.2815 4.78572 10.5714 4.78572C9.86134 4.78572 9.28571 5.36135 9.28571 6.07144C9.28571 6.78152 9.86134 7.35715 10.5714 7.35715Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 0.285721C3.73951 0.285721 0.285706 3.73952 0.285706 8.00001C0.285706 12.2605 3.73951 15.7143 7.99999 15.7143C12.2605 15.7143 15.7143 12.2605 15.7143 8.00001C15.7143 3.73952 12.2605 0.285721 7.99999 0.285721ZM1.57142 8.00001C1.57142 4.4496 4.44959 1.57144 7.99999 1.57144C11.5504 1.57144 14.4286 4.4496 14.4286 8.00001C14.4286 11.5504 11.5504 14.4286 7.99999 14.4286C4.44959 14.4286 1.57142 11.5504 1.57142 8.00001Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaceLaugh16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;